<template>
  <div
    v-if="props.plan != 'expert'"
    class="
    flex h-[70px] min-h-[70px] items-center justify-center
    transition-[width] duration-150
    "
    :class="{
      'w-[277px]': !collapsed,
      'w-0': collapsed,
    }"
  >
    <div
      class="w-[245px] min-w-[245px] origin-top-left transition-[transform,opacity] duration-150"
      :class="{
        'scale-100 opacity-100 ': !collapsed,
        'scale-0 opacity-0': collapsed,
      }"
    >
      <button
        class="
          flex w-full justify-center rounded-lg border border-[--v3-button-helpbuttonbg] bg-[--v3-button-helpbuttonbg]
          p-2 text-sm font-medium text-white transition-[font-size] duration-150
          hover:border-[--v3-button-helpbuttonhoverbordercolor] hover:bg-[--v3-button-helpbuttonhoverbg]
          active:border-[--v3-button-helpbuttonactivebordercolor] active:bg-[--v3-button-helpbuttonactivebg]
          "
        @click="handleClick"
      >
        <span
          class="font-bold"
        >
          {{ upgradeText }}
        </span>
      </button>
    </div>
  </div>
  <div v-else />
</template>

<script setup lang='ts'>
import { useConfirm } from 'primevue/useconfirm';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/common/stores/auth';
import { track } from '@/helpers/analytics/mixpanel';
import { usePaddleStore } from '@/modules/pricing/stores/paddle';
import type { Plan } from '@/types/global';

const props = withDefaults(defineProps<{
  collapsed?: boolean;
  plan: Plan;
}>(), {
  collapsed: false,
});


const router = useRouter();
const confirm = useConfirm();

const { t } = useI18n();
const authStore = useAuthStore();
const paddleStore = usePaddleStore();

const flag = ref(false);
const upgradeText = computed(() => {
  return t('layout.upgrade_plan');
});

const handleClick = () => {
  track('Clicked Upgrade', { Source: 'Sidebar' });
  if(flag.value == true) {
    confirm.require({
      group: 'headless',
      header: 'Your region is not supported ',
      message: `
        <p class='v3-body-regular-400-line-height-auto'>
          We’re sorry, but we are unable to accept your payment due to international sanctions regulations impacting your region.</p>
          <br><br>
          You may continue to use eRank as a Free member.
        </p>
      `,
      accept: () => confirm.close,
      acceptLabel: 'Close',
      rejectClass: 'hidden',
    });
  } else {
    const referrer = authStore.user.referrer;
    let redirect = '';
    switch (referrer) {
      case 'ad':
      case 'ad-sp':
        redirect = '/plans';
        break;
      case 'ad-reg':
        // Users from ad-reg should go directly to plans page
        redirect = '/plans';
        break;
      default:
        redirect = `/a/${referrer}`;
    }
    router.push(authStore.redirectToReferralPage && referrer && referrer !== 'ad-reg' ? redirect : '/plans');
  }
};

onMounted(async () => {
  try {
    if(authStore.isUserLogged) {
      flag.value = await paddleStore.checkPaddleRestriction();
    }
  } catch(e) { /* empty */ }
});
</script>


